import constitutionModalSteps from './constitutionModalSteps';

export const constitutionModalInitValue = {
  data: {
    date: '',
    comments: '',
    file: undefined,
    excelFile: undefined,
    notaryName: '',
    notaryProtocol: '',
    notaryCity: '',
    step: constitutionModalSteps.SCRIPTURE,
    lastOperationDate: '',
    totalSharesToAdd: 0,
    nominalValue: 0,
    selectedPartner: '',
    partnerOptions: [],
    sharesToAdd: 0,
    remainingShares: 0,
    hasPremium: false,
    premium: 0,
    selectedHoldingClass: '',
    defaultHoldingClassOption: null,
    holdingClassOptions: [],
    availableRange: { from: 0, to: 0 },
    historyMovements: [],
    excelPreview: null,
    excelRows: [],
    newPartnerCategories: [],
    isExcelMode: false,
    isValidateRangeEnabled: false,
    isLoadingRange: false,
    isLoading: false,
    isParsingExcel: false,
  },
  actions: {
    handleCloseModal(): void {},
    handleChangeDate(): void {},
    handleChangeComments(): void {},
    handleChangeFile(): void {},
    handleChangeExcelFile(): void {},
    handleDownloadExcelTemplate(): void {},
    handleChangeNotaryName(): void {},
    handleChangeNotaryProtocol(): void {},
    handleChangeNotaryCity(): void {},
    handleChangeTotalSharesToAdd(): void {},
    handleChangeNominalValue(): void {},
    handleChangePartner(): void {},
    handleSearchPartnerByTerm: async (): Promise<undefined> => undefined,
    handleChangeSharesToAdd(): void {},
    handleChangeHasPremium(): void {},
    handleChangePremium(): void {},
    handleChangeHoldingClass(): void {},
    handleValidateRange(): void {},
    handleSaveMovement(): void {},
    handleSaveConstitution(): void {},
    handleBackToScripture(): void {},
    handleExecuteFromExcel(): void {},
  },
};
